module.exports = __webpack_public_path__ + "img/Flamingo.087fc33b.png";